import Alpine from "../alpine.js"
import { createConsumer } from "@rails/actioncable"
import { client } from "../client.js"

Alpine.data("postLike", ({ postId, refresh }) => ({
  postId,
  refresh,
  like () {
    client.patch(`/posts/${this.postId}/like`)
      .then(() => {
        if (this.refresh) {
          Turbo.visit(window.location.href)
        }
      })
      .catch((error) => { console.log(error) })
  },
  unlike () {
    client.patch(`/posts/${this.postId}/unlike`)
      .then(() => {
        if (this.refresh) {
          Turbo.visit(window.location.href)
        }
      })
      .catch((error) => { console.log(error) })
  }
}))


